import request from '@/utils/request'

export function fetchContracts(query) {
  return request({
    url: '/contracts',
    method: 'get',
    params: query
  })
}

export function fetchContract(id) {
  return request({
    url: `/contracts/${id}`,
    method: 'get'
  })
}

export function createContract(data) {
  return request({
    url: '/contracts',
    method: 'post',
    data
  })
}

export function updateContract(id, data) {
  return request({
    url: `/contracts/${id}`,
    method: 'put',
    data
  })
}

export function updateContractDelivery(data) {
  return request({
    url: `/contracts/delivery`,
    method: 'put',
    data
  })
}

export function updateContractDeliveryCheck(data) {
  return request({
    url: `/contracts/delivery/check`,
    method: 'put',
    data
  })
}

export function cancelContractDelivery(data) {
  return request({
    url: `/contracts/delivery/cancel`,
    method: 'put',
    data
  })
}

export function updateContractSuccess(data) {
  return request({
    url: `/contracts/success`,
    method: 'put',
    data
  })
}

export function cancelContractSuccess(data) {
  return request({
    url: `/contracts/success/cancel`,
    method: 'put',
    data
  })
}

export function deleteContract(id) {
  return request({
    url: `/contracts/${id}`,
    method: 'delete'
  })
}


export function createContracts(data) {
  return request({
    url: `/contracts/scan`,
    method: 'post',
    data
  })
}

export function updateContractByTempbill(data) {
  return request({
    url: `/contracts`,
    method: 'put',
    data
  })
}

export function fetechContractTransition(data) {
  return request({
    url: `/contracts/transition`,
    method: 'post',
    data
  })
}

export function fetchContractList(query) {
  return request({
    url: '/contractslist',
    method: 'get',
    params: query
  })
}

export function updateContractById(id, data) {
  return request({
    url: `/contracts/update/${id}`,
    method: 'put',
    data
  })
}
